'use client';

import { useEffect, useState } from 'react';

/** Returns `value` delayed by `delayMs`, resetting the timer on each change. */
export function useDebouncedValue<T>(value: T, delayMs = 300): T {
    const [debounced, setDebounced] = useState(value);

    useEffect(() => {
        const timer = setTimeout(setDebounced, delayMs, value);
        return () => clearTimeout(timer);
    }, [value, delayMs]);

    return debounced;
}
